export interface BeastRegex {
  beast: string
  recipe: string
  regex: string
}
 
export const beastRegex: BeastRegex[] = [
  { beast: "Acid Slitherer", recipe: "", regex: "d sl"},
  { beast: "Adolescent Rhex", recipe: "", regex: "nt r"},
  { beast: "Alpine Devil", recipe: "", regex: "ne d"},
  { beast: "Alpine Shaman", recipe: "", regex: "e sh"},
  { beast: "Arakaali's Daughter", recipe: "", regex: "i's d"},
  { beast: "Arctic Wolf", recipe: "", regex: "tic w"},
  { beast: "Armour Cruncher", recipe: "", regex: "ur c"},
  { beast: "Avalanche Rider", recipe: "", regex: "he r"},
  { beast: "Avian Retch", recipe: "", regex: "an r"},
  { beast: "Barb Serpent", recipe: "", regex: "rb s"},
  { beast: "Barrow Ape", recipe: "", regex: "w a"},
  { beast: "Bearded Devil", recipe: "", regex: "d de"},
  { beast: "Bearded Shaman", recipe: "", regex: "ed sh"},
  { beast: "Bearded Skycaller", recipe: "", regex: "d sky"},
  { beast: "Black Scorpion", recipe: "", regex: "k sc"},
  { beast: "Bleached Crawler", recipe: "", regex: "ached c"},
  { beast: "Blood Ape", recipe: "", regex: "od a"},
  { beast: "Blood Chieftain", recipe: "", regex: "od c"},
  { beast: "Bone Cruncher", recipe: "", regex: "one c"},
  { beast: "Bone Rhoa", recipe: "", regex: "one r"},
  { beast: "Bramble Cobra", recipe: "", regex: "mble c"},
  { beast: "Brine Vassal", recipe: "", regex: "ne va"},
  { beast: "Brooding Tarantula", recipe: "", regex: "g tar"},
  { beast: "Buried Tarantula", recipe: "", regex: "d ta"},
  { beast: "Carnage Ape", recipe: "", regex: "e ap"},
  { beast: "Carnage Chieftain", recipe: "", regex: "ge ch"},
  { beast: "Carrion Burrower", recipe: "", regex: "n bu"},
  { beast: "Carrion Queen", recipe: "", regex: "Carrion Queen"},
  { beast: "Carrion Swarmer", recipe: "", regex: "on sw"},
  { beast: "Cave Beast", recipe: "", regex: "ve b"},
  { beast: "Cave Skitterer", recipe: "", regex: "ve s"},
  { beast: "Cavern Drifter", recipe: "", regex: "rn d"},
  { beast: "Chimeric Croaker", recipe: "", regex: "c cro"},
  { beast: "Chrome-infused Chimeral", recipe: "", regex: "sed ch"},
  { beast: "Chrome-infused Croaker", recipe: "", regex: "used cr"},
  { beast: "Chrome-infused Goliath", recipe: "", regex: "used g"},
  { beast: "Chrome-touched Chimeral", recipe: "", regex: "hed ch"},
  { beast: "Chrome-touched Croaker", recipe: "", regex: "hed cro"},
  { beast: "Chrome-touched Goliath", recipe: "", regex: "hed g"},
  { beast: "Colossus Crusher", recipe: "", regex: "us c"},
  { beast: "Corrupted Arach", recipe: "", regex: "ted ar"},
  { beast: "Corrupted Beast", recipe: "", regex: "ted b"},
  { beast: "Corrupted Rhoa", recipe: "", regex: "pted r"},
  { beast: "Craiceann, First of the Deep", recipe: "Craft an Aspect Skill onto an Item - Aspect of the Crab skill", regex: "n, f"},
  { beast: "Craicic Chimeral", recipe: "Create an Imprint - Of a Magic Item", regex: "cic c"},
  { beast: "Craicic Maw", recipe: "Modify Mods on an Item - Add a Mod to a Crusader Item", regex: "cic m"},
  { beast: "Craicic Sand Spitter", recipe: "Create Currency Items - A Stack of 2 Orbs of Binding", regex: "c san"},
  { beast: "Craicic Savage Crab", recipe: "Create a Unique - Item", regex: "c sav"},
  { beast: "Craicic Shield Crab", recipe: "Create Currency Items - A Stack of 2 Orbs of Binding", regex: "c sh"},
  { beast: "Craicic Spider Crab", recipe: "Open a Portal - to Craiceann's Cove", regex: "c sp"},
  { beast: "Craicic Squid", recipe: "Create a Unique - Jewel", regex: " sq"},
  { beast: "Craicic Vassal", recipe: "Corrupt an Item - Double Corrupt a Map", regex: "c v"},
  { beast: "Craicic Watcher", recipe: "Create a Unique - Claw or Dagger", regex: "c wa"},
  { beast: "Crustacean Sniper", recipe: "", regex: "n sn"},
  { beast: "Crypt Ambusher", recipe: "", regex: "t am"},
  { beast: "Crypt Weaver", recipe: "", regex: "t w"},
  { beast: "Cursed Spawn", recipe: "", regex: "sed s"},
  { beast: "Devourer", recipe: "", regex: "Devourer"},
  { beast: "Dirt Scrabbler", recipe: "", regex: "rt s"},
  { beast: "Diseased Arachnid", recipe: "", regex: "sed ara"},
  { beast: "Dread Primate", recipe: "", regex: "ad p"},
  { beast: "Dune Hellion", recipe: "", regex: "ne h"},
  { beast: "Dust Scrabbler", recipe: "", regex: "ust s"},
  { beast: "Elder-Blessed Cobra", recipe: "", regex: "d co"},
  { beast: "Elder-Blessed Goatman", recipe: "", regex: "d goa"},
  { beast: "Elder-Blessed Hellion", recipe: "", regex: "sed h"},
  { beast: "Elder-Blessed Retch", recipe: "", regex: "d re"},
  { beast: "Elder-Blessed Rhoa", recipe: "", regex: "sed rh"},
  { beast: "Enraptured Arachnid", recipe: "", regex: "red a"},
  { beast: "Enraptured Beast", recipe: "", regex: "ured b"},
  { beast: "Enraptured Crab", recipe: "", regex: "red c"},
  { beast: "Enslaved Hellion", recipe: "", regex: "ved h"},
  { beast: "Escaped Rhex", recipe: "", regex: "ped r"},
  { beast: "Farric Ape", recipe: "Create a Unique - Belt", regex: "c a"},
  { beast: "Farric Chieftain", recipe: "Create a Unique - Amulet", regex: "rric c"},
  { beast: "Farric Flame Hellion Alpha", recipe: "Create a Unique - Ring", regex: "c fl"},
  { beast: "Farric Frost Hellion Alpha", recipe: "Create Currency Items - A Stack of 3 Orbs of Horizons", regex: "c fr"},
  { beast: "Farric Gargantuan", recipe: "Create a Unique - Helmet", regex: "c ga"},
  { beast: "Farric Goatman", recipe: "Create a Unique - Flask", regex: "c goa"},
  { beast: "Farric Goliath", recipe: "Create a Unique - Bow", regex: "c gol"},
  { beast: "Farric Lynx Alpha", recipe: "Modify Mods on an Item - Add a Suffix, Remove a Random Prefix", regex: "c l"},
  { beast: "Farric Magma Hound", recipe: "Create an Item - 23% Quality Corrupted Gem", regex: "ma h"},
  { beast: "Farric Pit Hound", recipe: "Create an Item - Level 21 Corrupted Gem", regex: "c pi"},
  { beast: "Farric Taurus", recipe: "Create a Unique - Map", regex: "ic ta"},
  { beast: "Farric Tiger Alpha", recipe: "Open a Portal - to Farrul's Den", regex: "c ti"},
  { beast: "Farric Ursa", recipe: "Create a Unique - Body Armour", regex: "c u"},
  { beast: "Farric Wolf Alpha", recipe: "Modify Mods on an Item - Add a Prefix, Remove a Random Suffix", regex: "f al"},
  { beast: "Farrul, First of the Plains", recipe: "Craft an Aspect Skill onto an Item - Aspect of the Cat skill", regex: "ul, f"},
  { beast: "Fenumal Devourer", recipe: "Create a Unique - Shield or Quiver", regex: "mal d"},
  { beast: "Fenumal Hybrid Arachnid", recipe: "Open a Portal - to Fenumus' Lair", regex: "l hy"},
  { beast: "Fenumal Plagued Arachnid", recipe: "Split an Item Into Two - With Half the Mods on Each Item", regex: "l pla"},
  { beast: "Fenumal Queen", recipe: "Create a Unique - Staff", regex: "l q"},
  { beast: "Fenumal Scorpion", recipe: "Convert this Unique Item - Into Another Random Unique Item", regex: "l sco"},
  { beast: "Fenumal Scrabbler", recipe: "Create a Unique - Wand", regex: "l scr"},
  { beast: "Fenumal Widow", recipe: "Create a Unique - Gloves", regex: "l w"},
  { beast: "Fenumus, First of the Night", recipe: "Craft an Aspect Skill onto an Item - Aspect of the Spider skill", regex: "s, f"},
  { beast: "Feral Chimeral", recipe: "", regex: "l chi"},
  { beast: "Fetid Maw", recipe: "", regex: "id m"},
  { beast: "Fighting Bull", recipe: "", regex: "g bu"},
  { beast: "Filth Maw", recipe: "", regex: "th m"},
  { beast: "Flame Hellion", recipe: "", regex: "Flame Hellion"},
  { beast: "Forest Beast", recipe: "", regex: "st b"},
  { beast: "Freezing Wolf", recipe: "", regex: "g wo"},
  { beast: "Fury Hound", recipe: "", regex: "y h"},
  { beast: "Glade Mamba", recipe: "", regex: "de m"},
  { beast: "Gluttonous Gull", recipe: "", regex: "us g"},
  { beast: "Goatman", recipe: "", regex: "Goatman"},
  { beast: "Goatman Fire-raiser", recipe: "", regex: "n fi"},
  { beast: "Goatman Shaman", recipe: "", regex: "an sh"},
  { beast: "Goatman Stomper", recipe: "", regex: "n st"},
  { beast: "Granite Eater", recipe: "", regex: "e e"},
  { beast: "Gravel Eater", recipe: "", regex: "el e"},
  { beast: "Grazing Taurus", recipe: "", regex: "g tau"},
  { beast: "Hairy Bonecruncher", recipe: "", regex: "y bo"},
  { beast: "Hatchling", recipe: "", regex: "Hatchling"},
  { beast: "Hill Devil", recipe: "", regex: "ill d"},
  { beast: "Host Adder", recipe: "", regex: "st a"},
  { beast: "Host Chieftain", recipe: "", regex: "t ch"},
  { beast: "Host Cobra", recipe: "", regex: "t cob"},
  { beast: "Hybrid Arachnid", recipe: "", regex: "Hybrid Arachnid"},
  { beast: "Infested Ape", recipe: "", regex: "ed ap"},
  { beast: "Infested Crab", recipe: "", regex: "ted crab"},
  { beast: "Infested Crawler", recipe: "", regex: "ted craw"},
  { beast: "Infested Maw", recipe: "", regex: "ed ma"},
  { beast: "Infested Rhoa", recipe: "", regex: "sted r"},
  { beast: "Infested Serpent", recipe: "", regex: "ed se"},
  { beast: "Infested Skitterer", recipe: "", regex: "ted sk"},
  { beast: "Infested Tunnelfiend", recipe: "", regex: "d tu"},
  { beast: "Infested Ursa", recipe: "", regex: "d u"},
  { beast: "Infested Vulture", recipe: "", regex: "ed v"},
  { beast: "Ink Spinner", recipe: "", regex: "nk s"},
  { beast: "Leaping Spider", recipe: "", regex: "g sp"},
  { beast: "Lurking Venom", recipe: "", regex: "g ve"},
  { beast: "Maternal Rhex", recipe: "", regex: "nal r"},
  { beast: "Merveil's Attendant", recipe: "", regex: "'s a"},
  { beast: "Merveil's Blessed", recipe: "", regex: "'s b"},
  { beast: "Merveil's Chosen", recipe: "", regex: " cho"},
  { beast: "Merveil's Daughter", recipe: "", regex: "il's d"},
  { beast: "Merveil's Favoured", recipe: "", regex: "'s f"},
  { beast: "Merveil's Retainer", recipe: "", regex: "'s re"},
  { beast: "Mindless Scavenger", recipe: "", regex: "ss s"},
  { beast: "Mountain Hellion", recipe: "", regex: "Mountain Hellion"},
  { beast: "Mountain Hellion Alpha", recipe: "", regex: "n hellion a"},
  { beast: "Mountain Lynx", recipe: "", regex: "in l"},
  { beast: "Murk Runner", recipe: "", regex: "k r"},
  { beast: "Mutant Arach", recipe: "", regex: "nt a"},
  { beast: "Night Adder", recipe: "", regex: "ht a"},
  { beast: "Noxious Tarantula", recipe: "", regex: "us t"},
  { beast: "Obsidian Eater", recipe: "", regex: "ian e"},
  { beast: "Pitbull Demon", recipe: "", regex: "ull d"},
  { beast: "Plagued Arachnid", recipe: "", regex: "Plagued Arachnid"},
  { beast: "Plated Parasite", recipe: "", regex: "ed p"},
  { beast: "Plumed Chimeral", recipe: "", regex: "med c"},
  { beast: "Plummeting Ursa", recipe: "", regex: "Plummeting Ursa"},
  { beast: "Porcupine Goliath", recipe: "", regex: "ne g"},
  { beast: "Predatory Scorpion", recipe: "", regex: "ry s"},
  { beast: "Primal Crushclaw", recipe: "Gain Atlas Crafts - Gain a free use of each Map Crafting Option", regex: "l cru"},
  { beast: "Primal Cystcaller", recipe: "Gain Atlas Crafts - Gain one of each Atlas Mission", regex: " cy"},
  { beast: "Primal Rhex Matriarch", recipe: "Create an Item - Vaal Temple Map", regex: "x ma"},
  { beast: "Purge Hound", recipe: "", regex: "ge h"},
  { beast: "Ravenous Parasite", recipe: "", regex: "nous p"},
  { beast: "Rhoa Mare", recipe: "", regex: "oa m"},
  { beast: "Rock Spitter", recipe: "", regex: "ock s"},
  { beast: "Rooster Demon", recipe: "", regex: "r de"},
  { beast: "Rooster Fiend", recipe: "", regex: "r fi"},
  { beast: "Rotting Vulture", recipe: "", regex: "ting v"},
  { beast: "Ruins Hellion", recipe: "", regex: "ns h"},
  { beast: "Sand Leaper", recipe: "", regex: "d l"},
  { beast: "Sand Scorpion", recipe: "", regex: "nd sc"},
  { beast: "Sand Serpent", recipe: "", regex: "nd se"},
  { beast: "Sand Skitterer", recipe: "", regex: "nd sk"},
  { beast: "Saqawal, First of the Sky", recipe: "Craft an Aspect Skill onto an Item - Aspect of the Avian skill", regex: "al, f"},
  { beast: "Saqawine Blood Viper", recipe: "Create a Unique - Sword or Axe", regex: "ne b"},
  { beast: "Saqawine Chimeral", recipe: "Create Currency Items - A Stack of 10 Random Currency", regex: "ne ch"},
  { beast: "Saqawine Cobra", recipe: "Create a Unique - Mace or Sceptre", regex: "ne co"},
  { beast: "Saqawine Retch", recipe: "Create a Unique - Boots", regex: "e re"},
  { beast: "Saqawine Rhex", recipe: "Open a Portal - to Saqawal's Roost", regex: "e rhe"},
  { beast: "Saqawine Rhoa", recipe: "Create Currency Items - A Stack of 8 Chromatic Orbs", regex: "ine rho"},
  { beast: "Saqawine Vulture", recipe: "Create an Item - Fully-linked Six-socket Rare", regex: "e vu"},
  { beast: "Savage Crab", recipe: "", regex: "Savage Crab"},
  { beast: "Scalding Arachnid", recipe: "", regex: "g a"},
  { beast: "Scavenging Vulture", recipe: "", regex: "ging v"},
  { beast: "Scum Crawler", recipe: "", regex: "um c"},
  { beast: "Sewage Crawler", recipe: "", regex: "wage c"},
  { beast: "Sewer Drifter", recipe: "", regex: "r dr"},
  { beast: "Shackled Hellion", recipe: "", regex: "led h"},
  { beast: "Shaggy Monstrosity", recipe: "", regex: "gy m"},
  { beast: "Singing Siren", recipe: "", regex: "g si"},
  { beast: "Skeletal Beast", recipe: "", regex: "tal b"},
  { beast: "Slimy Nemesis", recipe: "", regex: "y n"},
  { beast: "Snow Wolf", recipe: "", regex: "w w"},
  { beast: "Soulless Watcher", recipe: "", regex: "ss w"},
  { beast: "Spindle Spider", recipe: "", regex: "dle s"},
  { beast: "Spine Serpent", recipe: "", regex: "e se"},
  { beast: "Spitting Parasite", recipe: "", regex: "g p"},
  { beast: "Stygian Ape", recipe: "", regex: "n ap"},
  { beast: "Sulphuric Scorpion", recipe: "", regex: "c sc"},
  { beast: "Sulphurspawn", recipe: "", regex: "Sulphurspawn"},
  { beast: "Swarthy Mollusc", recipe: "", regex: "hy m"},
  { beast: "Talon Archer", recipe: "", regex: "lon a"},
  { beast: "Tercel Rhoa", recipe: "", regex: "cel r"},
  { beast: "Thicket Hulk", recipe: "", regex: " hu"},
  { beast: "Toxic Crawler", recipe: "", regex: "xic c"},
  { beast: "Tunnelfiend", recipe: "", regex: "Tunnelfiend"},
  { beast: "Vaal Recluse", recipe: "", regex: " rec"},
  { beast: "Vaulting Croaker", recipe: "", regex: "g cro"},
  { beast: "Venomous Spawn", recipe: "", regex: "us s"},
  { beast: "Vicious Parasite", recipe: "", regex: "ious p"},
  { beast: "Virulent Spider", recipe: "", regex: "lent s"},
  { beast: "Vivid Abberarach", recipe: "Create an Item - Shaper Guardian, Elder Guardian or Conqueror Map", regex: " ab"},
  { beast: "Vivid Vulture", recipe: "Modify Mods on an Item - Reroll a Synthesis implicit modifier", regex: "id v"},
  { beast: "Vivid Watcher", recipe: "Transform an Item - Reroll an Awakened Support Gem (Cannot result in Awakened Empower, Enhance, or Enlighten)", regex: "id w"},
  { beast: "War Hound", recipe: "", regex: "ar h"},
  { beast: "Waste Lurcher", recipe: "", regex: "te l"},
  { beast: "Webbed Spider", recipe: "", regex: "bed s"},
  { beast: "Wild Brambleback", recipe: "Transform an Item - Increase level of non-Corrupted Awakened Gem by 1", regex: "d bra"},
  { beast: "Wild Bristle Matron", recipe: "Modify Mods on an Item - Add a crafted Meta-modifier to a non-Unique Item", regex: "d bri"},
  { beast: "Wild Hellion Alpha", recipe: "Modify Mods on an Item - Reroll a Watcher's Eye", regex: "ld h"},
  { beast: "Wild Rhex", recipe: "", regex: "ld r"},
  { beast: "Woods Ursa", recipe: "", regex: "ds u"},
]